export const FAVORITE_TYPE_LAWYER: number = 1;
export const FAVORITE_TYPE_ARTICLE: number = 3;
